import React, { useState } from "react";
import { createContext } from "react";
import { UserTypes } from "../interfaces/UserTypes";

type UserContextType = {
  user: UserTypes | undefined;
  setUser: React.Dispatch<React.SetStateAction<UserTypes | undefined>>;
};

const iUserContextState: UserContextType = {
  user: undefined,
  setUser: () => {},
};

export const UserContext = createContext<UserContextType>(iUserContextState);

export default function UserProvider(props: any) {
  const [user, setUser] = useState<UserTypes>();

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
}
